import { render, staticRenderFns } from "./TicketDetailInfo.vue?vue&type=template&id=6d78c996&scoped=true"
import script from "./TicketDetailInfo.vue?vue&type=script&lang=js"
export * from "./TicketDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./TicketDetailInfo.vue?vue&type=style&index=0&id=6d78c996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d78c996",
  null
  
)

export default component.exports